import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { Fragment, useMemo } from 'react';
import cn from 'classnames';
import { Box, IconButton, Row, TextButton, Typography } from 'seagull';
import { CloseCross } from 'seagull/icons/essentials';
import { getTestIds } from 'seagull/utils/TestIds';
import styles from './FilterChip.module.scss';
export const GetFilterChipTID = (parentTestId)=>getTestIds(parentTestId);
export const FilterChip = (param)=>{
    let { testId, fieldLabel, operator, valuePrefix, valueLabel, valueSegments, combinator, onValueClick, onFieldClick, onRemove, removeBiName, tone = 'default' } = param;
    const { FilterChipTestIds } = useMemo(()=>GetFilterChipTID(testId), [
        testId
    ]);
    const isWarning = tone === 'warning';
    const hasSegments = valueSegments != null && valueSegments.length > 0;
    return /*#__PURE__*/ _jsx(Box, {
        testId: FilterChipTestIds.Root(),
        inline: true,
        className: cn(styles.root, {
            [styles.warning]: isWarning
        }),
        children: /*#__PURE__*/ _jsxs(Row, {
            alignItems: "center",
            gap: 4,
            children: [
                fieldLabel !== '' && /*#__PURE__*/ _jsx(Box, {
                    testId: FilterChipTestIds.Field(),
                    inline: true,
                    onClick: onFieldClick,
                    className: cn(styles.field, {
                        [styles.clickable]: onFieldClick != null
                    }),
                    children: /*#__PURE__*/ _jsx(Typography, {
                        variant: "paragraph2",
                        className: styles.fieldText,
                        children: fieldLabel
                    })
                }),
                operator != null && /*#__PURE__*/ _jsx(TextButton, {
                    testId: FilterChipTestIds.Operator(),
                    bi: {
                        name: operator.biName
                    },
                    onClick: operator.onToggle,
                    variant: "paragraph2",
                    skin: "primary",
                    underline: "none",
                    children: operator.label
                }),
                valuePrefix != null && /*#__PURE__*/ _jsx(Box, {
                    testId: FilterChipTestIds.ValuePrefix(),
                    inline: true,
                    className: styles.valuePrefix,
                    children: /*#__PURE__*/ _jsx(Typography, {
                        variant: "paragraph2",
                        skin: "primary",
                        children: valuePrefix
                    })
                }),
                hasSegments ? valueSegments.map((segment, index)=>/*#__PURE__*/ _jsxs(Fragment, {
                        children: [
                            index > 0 && /*#__PURE__*/ _jsx(Typography, {
                                testId: FilterChipTestIds.Combinator(index),
                                variant: "paragraph2",
                                className: styles.combinator,
                                children: combinator
                            }),
                            /*#__PURE__*/ _jsx(Box, {
                                testId: FilterChipTestIds.Segment(index),
                                inline: true,
                                onClick: segment.onClick,
                                className: cn(styles.value, {
                                    [styles.clickable]: segment.onClick != null
                                }),
                                children: /*#__PURE__*/ _jsx(Typography, {
                                    variant: "paragraph2",
                                    className: styles.valueText,
                                    children: segment.label
                                })
                            })
                        ]
                    }, "".concat(index, "-").concat(segment.label))) : valueLabel != null && valueLabel !== '' && /*#__PURE__*/ _jsx(Box, {
                    testId: FilterChipTestIds.Value(),
                    inline: true,
                    onClick: onValueClick,
                    className: cn(styles.value, {
                        [styles.clickable]: onValueClick != null
                    }),
                    children: /*#__PURE__*/ _jsx(Typography, {
                        variant: "paragraph2",
                        className: styles.valueText,
                        children: valueLabel
                    })
                }),
                /*#__PURE__*/ _jsx(Box, {
                    className: styles.removeButton,
                    children: /*#__PURE__*/ _jsx(IconButton, {
                        testId: FilterChipTestIds.Remove(),
                        bi: {
                            name: removeBiName
                        },
                        onClick: onRemove,
                        size: "small",
                        children: /*#__PURE__*/ _jsx(CloseCross, {
                            size: 10
                        })
                    })
                })
            ]
        })
    });
};
